module.exports = __webpack_public_path__ + "img/icons_25.a969c4f4.svg";